<template #bidContainer></template>
<div *ngIf="AnyProcessing" class="loading-overlay">
  <i class="text-white fa fa-2x fa-spin fa-spinner"></i>
</div>
<div class="modal-header bg-neutral-50 pb-1">
  <h4 class="modal-title" *ngIf="!IsConfirmBidsClicked">Review your bids</h4>
  <div *ngIf="IsConfirmBidsClicked" class="d-flex flex-1">
    <h4 class="modal-title flex-1">Here’s an update of your auction</h4>
  </div>
  <button type="button" class="close text-white" aria-label="Close" (click)="activeModal.close(null)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body border-0 bg-neutral-25 modal-confirm-bids pb-1 pt-1">
  <div *ngIf="IsConfirmBidsClicked" class="d-flex pb-0 mb-1 auction-final-update flex-column flex-md-row">
    <div class="d-flex flex-column flex-1">
      <h5>Results</h5>
      <div class="text-opacity-7">{{losingBids.length}} unsuccessful bids</div>
      <div class="text-opacity-7">{{winningBids.length}} successful bids</div>
      <div class="text-opacity-7">{{notAcceptedBids.length}} bids not accepted</div>
    </div>
    <div class="d-flex flex-column flex-1 mt-2 mt-md-0">
      <h5>Auction Overview</h5>
      <div class="">Current winning bids<span class="text-red font-weight-bold">
          {{myAuctionLotService.currentWinningBids | inDollars}}
          <!-- $4740 (+3 new items) -->
        </span></div>
      <div>Current maximum bids<span class="text-red font-weight-bold">
          {{myAuctionLotService.currentMaximum | inDollars}}
          <!-- $4740 (+3 new items) -->
        </span></div>
    </div>
  </div>
  <form #thisForm="ngForm" *ngIf="!IsBidAgainClicked">
    <div class="row auction-headers d-none d-lg-flex p-3" *ngIf="!IsConfirmBidsClicked || HasUnsuccessfulBids">
      <h5 class="flex-basis-100 mb-1" *ngIf="HasUnsuccessfulBids">Your unsuccessful bids:</h5>
      <div class="cell cell-auction-info flex-2">Item</div>
      <div class="cell flex-1">Winning Bid</div>
      <div class="cell flex-1">Your Max Bid (per bottle)</div>
    </div>
    <ng-container *ngFor="let bid of bids">
      <div *ngIf="IsConfirmBidsClicked" class="">
        <div *ngIf="losingBids.indexOf(bid.lot.Id) === 0" class="row bg-yellow text-white px-3 py-2">Losing bids:</div>
        <div *ngIf="winningBids.indexOf(bid.lot.Id) === 0" class="row bg-green text-white px-3 py-2">Winning bids:</div>
        <div *ngIf="notAcceptedBids.indexOf(bid.lot.Id) === 0" class="row bg-light-grey text-white px-3 py-2">Not Accepted bids:</div>
      </div>
      <div class="row auction-data flex-column flex-lg-row pl-3 pr-3 pt-2 pb-2 mb-2" name="bids" ngDefaultControl [ngClass]="[ (!IsConfirmBidsClicked && (!bid.LotIsBiddable || (!bid.newBidAmt || !bid.NewBidIsValid))) || (IsConfirmBidsClicked && !bid.newBitAmt && !bid.LotIsBiddable && !bid.NewBidIsValid && notAcceptedBids.indexOf(bid.lot.Id) < 0 && losingBids.indexOf(bid.lot.Id) < 0) ? 'text-opacity-7' : '', (false) ? 'd-none': '']">
        <div class="cell cell-auction-info flex-2">
          <div class="row auction-info">
            <div class="d-flex flex-column col-12">
              <h5 class="text-red m-0 text-uppercase">{{bid.lot.WineryName}}</h5>
              <p *ngIf="bid.lot.IsMixedLot" class="mb-0">
                <span *ngFor="let mixedLot of bid.lot.AuctionMixedLots" class="d-block">{{mixedLot.Quantity}} x {{mixedLot.WineDefinition?.Wine?.Winery?.Name}} {{mixedLot.WineDefinition?.Wine?.Name}} {{mixedLot.WineDefinition?.Vintage}} ({{mixedLot.WineDefinition?.UnitOfMeasure?.Abbreviation}})</span>
              </p>
              <p *ngIf="!bid.lot.IsMixedLot" class="mb-0">{{bid.lot.Vintage>0 ? bid.lot.Vintage + '&nbsp;' : ''}}{{bid.lot.WineName}}, {{ Format([bid.lot.WineVarietyName, bid.lot.WineryRegionName, bid.lot.WineryCountryName]) }}, <span class="mr-3 text-opacity-7">{{bid.lot.Quantity}} * {{bid.lot.UnitOfMeasureName}}</span></p>
              <!-- <div>
                <span class="mr-3 text-opacity-7">Lot: {{bid.lot.LotNumber}}</span>
                <span class="mr-3 text-opacity-7">{{bid.lot.Quantity}} * {{bid.lot.UnitOfMeasure?.Name}}</span>
              </div> -->
              <div *ngIf="!bid.lot.IsMixedLot" class="auction-card-footer mt-1 d-flex">
                <ng-container *ngFor="let codedComment of bid.lot.AuctionLotCodedComments;">
                  <span class="mr-4 text-opacity-7 font-sm" *ngIf="codedComment.Quantity > 0">
                    {{codedComment.CodedCommentDefinition.Title}}
                  </span>
                </ng-container>
                <ng-container *ngFor="let lotAttribute of bid.lot.AuctionLotAttributes;">
                  <span class="mr-4 text-opacity-7 font-sm" *ngIf="lotAttribute.Quantity > 0">
                    {{bid.lot.Quantity>1 ? lotAttribute.Quantity + ' x' : ''}} {{lotAttribute.AttributeDefinition.Title}}
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="cell d-flex flex-1 flex-column flex-lg-row mt-3 mt-lg-0">
          <h6 class="d-lg-none">Winning Bid</h6>
          <div class="d-flex flex-row flex-lg-column"><span class="mr-3">{{bid.lot.CurrentBid | inDollars}}</span>
            <div><span class="p-1 font-sm text-uppercase" [ngClass]="[ bid.IsWinning ? 'bg-green' : bid.IsOutbid ? 'bg-yellow' : '']">{{bid.Status}}</span>
            </div>
          </div>
        </div>
        <div class="cell mt-3 mt-lg-0 text-height-8 d-lg-flex flex-1">
          <h6 class="d-lg-none">New Max Bid (per bottle)</h6>
          <div class="d-flex w-100">
            <div class="form-group mb-0 flex-1">
              <div *ngIf="bid.LotIsBiddable && IsConfirmBidsClicked" class="input-group mb-1 pr-2">
                <div class="input-group-prepend">
                  <span class="input-group-text rounded-0 pl-0">$</span>
                </div>
                <input type="number" #bidEntry aria-label="Amount (to the nearest dollar)" class="form-control pl-0 rounded-0" (keydown)="bidAmountChanged(bid)" (keydown.enter)="$event.preventDefault()" (keyup.enter)="SetFocus(true)" (blur)="bid.BidChange(true)" [(ngModel)]="bid.newBidAmt" (change)="bid.BidChange(true)" [ngModelOptions]="{standalone: true}">
              </div>
              <div *ngIf="bid.LotIsBiddable && !IsConfirmBidsClicked" class="input-group mb-1 pr-2">
                <span class="py-2 pl-0 border-0 rounded-0">{{bid.newBidAmt | inDollars}}</span>
              </div>
              <div *ngIf="bid.LotIsBiddable && bid.newBidAmt && !bid.NewBidIsValid" class="error-label text-red w-100 text-height-18 mb-1 font-sm">Invalid amount ({{ bid.MinimumBid | inDollars }}+)</div>
              <span *ngIf="!bid.LotIsBiddable || (bid.newBidAmt && !bid.NewBidIsValid)" class="font-sm badge badge-secondary p-1 font-weight-normal rounded-0" ngbTooltip="Bid will not be accepted. Bid empty or doesn't meet minimum bid amount.">Not acceptable</span>
              <!-- <span *ngIf="bid.LotIsBiddable && bid.NewBidIsValid && !bid.NewBidAmountValidated" (click)="bid.AdjustToIncrement()" class="font-sm badge badge-warning cursor-pointer p-1 font-weight-normal rounded-0" ngbTooltip="Bid meets minimum amount but has not yet been adjusted to the nearest increment.">Tentative</span> -->
              <!-- <span *ngIf="bid.LotIsBiddable && bid.NewBidIsValid && bid.NewBidAmountValidated" class="font-sm badge badge-success p-1 font-weight-normal rounded-0" ngbTooltip="Bid is valid and meets minimum bid amount.">Acceptable</span> -->
              <div *ngIf="bid.processing" @fade class="badge" style="vertical-align: text-bottom;"><i class="fa fa-2x fa-spin fa-spinner"></i></div>
              <span *ngIf="bid.oldBidAmt && bid.NewBidIsValid" class="font-sm badge badge-danger p-1 font-weight-normal rounded-0" ngbTooltip="Price adjusted down from {{bid.oldBidAmt | inDollars}}">&darr; {{bid.oldBidAmt | inDollars}}</span>
              <div *ngIf="bid.AuctionHasExpired && !bid.LotIsBiddable" class="font-sm badge badge-danger p-1 font-weight-normal rounded-0 w-100 mt-1" ngbTooltip="This lot is now closed.">Closed</div>
              <div *ngIf="bid.AuctionHasExpired && bid.LotIsBiddable" class="font-sm badge badge-warning p-1 font-weight-normal rounded-0 w-100 mt-1" ngbTooltip="This lot is in right of reply mode.">Right of reply</div>
              <div *ngIf="bid.errorMessage" class="col-12 font-sm badge badge-danger p-1 font-weight-normal rounded-0 w-100 mt-1" ngbTooltip="{{bid.errorMessage}}">Something went wrong</div>
            </div>
            <div class="d-flex flex-column">
              <button tabindex="-1" class="btn btn-favourite p-2 mb-2" (click)="DeleteBidItem(bid)"><i class="fa fa-close" aria-hidden="true"></i></button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="!AnyProcessing && IsConfirmBidsClicked && !HasUnsuccessfulBids">
      <h3 class="p-4 mb-0 text-center">Congratulations, you have successfully bid on all your items</h3>
    </div>

    <div *ngIf="Items > 0 && !IsConfirmBidsClicked" class="row mt-2 mx-2">
      <div class="col-6">
        <span class="d-block">Items</span>
        <span class="d-block">Total Max Bid</span>
        <span class="d-block">BPA {{BuyerPremium | percent:'1.0-2'}}</span>
        <span class="text-red d-block">Total</span>
      </div>
      <div class="col-6 text-right">
        <span class="d-block">{{ Items }}</span>
        <span class="d-block">{{ SubTotal | inDollars }}</span>
        <span class="d-block">{{ PremiumTotal | inDollars }}</span>
        <span class="text-red d-block">{{ Total | inDollars }}</span></div>
    </div>
  </form>
</div>
<div class="modal-footer border-0 bg-neutral-50">
  <div class="row w-100 d-flex align-items-center">
    <div class="col-lg-6 col-xs-12 p-0 pr-lg-2 pb-2 pb-lg-0" [ngClass]="{'col-lg-12': IsBidAgainClicked }">
      <button #backToWatchList type="button" class="btn border-red p-2 w-100 rounded-0 mr-md-3" (keydown.enter)="$event.preventDefault()" (keyup.enter)="backToWatchList.click()" (click)="BackToBidsList()" [disabled]="AnyProcessing">Back to Watch & List Bid</button>
    </div>
    <div class="col-lg-6 col-xs-12 p-0">
      <div>
        <div #noValidBids="ngbTooltip" ngbTooltip="No valid bids available" triggers="manual" (mouseenter)="!AnyProcessing && ValidBids.length === 0 && noValidBids.open()" [disableTooltip]="ValidBids.length > 0">
          <button #confirmBids (keydown.enter)="$event.preventDefault()" (keyup.enter)="confirmBids.click()" type="button" class="btn btn-primary btn-red p-2 w-100" (click)="ConfirmBids()" *ngIf="!IsConfirmBidsClicked" [disabled]="AnyProcessing || ValidBids.length === 0">Confirm Bids</button>
        </div>
        <button #confirmBids (keydown.enter)="$event.preventDefault()" (keyup.enter)="confirmBids.click()" type="button" class="btn btn-primary btn-red p-2 w-100" (click)="BackToConfirmation();" *ngIf="IsConfirmBidsClicked && !IsBidAgainClicked" [disabled]="AnyProcessing || !IsBidAmountChanged || !HasPossibleBids">Bid again</button>
      </div>
    </div>
  </div>
